import React, { useContext, useState, useEffect, useRef } from 'react'
import { InputAdornment, IconButton } from '@mui/material'
import moment from 'moment'
import * as Yup from 'yup'
import CustomCommonContext from '../../../../../custom/context/common/commonContext'
import ProductCommonContext from '../../../../context/product/productContext'
import PropTypes from 'prop-types'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import UserInvoices from '../Tabs/UserInvoices'
import LoginInfo from '../Tabs/LoginInfo'
import Credits from '../Tabs/Credits'
import UserEmailLogs from '../Tabs/UserEmailLogs'
import UserNotifications from '../Tabs/UserNotifications'
import UserBidHistory from '../Tabs/UserBidHistory'
import UserSmsLogs from '../Tabs/UserSmsLogs'
import PrimaryButton from '../../../../../product/components/atoms/PrimaryButton'
import SecondaryButton from '../../../../../product/components/atoms/SecondaryButton'
import FullScreenPopup from '../../FullScreenPopup'
import AuthContext from '../../../../../product/context/auth/authContext'
import { useFormik } from 'formik'
import {
    mapData,
    dateFormatFunction,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../../../../product/common/components'
import BaseActionPage from '../../../../../product/components/species/dynamic/common/BaseActionPage'
import UserContext from '../../../../../product/context/user/userContext'
import Loaders from '../../../../../product/components/molecules/Loaders'
import ListingTableView from '../../../../../product/components/organisms/Product/TableView'
import ProductContext from '../../../../../product/context/userProduct/productContext'
import BuyerBids from '../Tabs/BuyerBids'
import { useTranslation } from 'react-i18next'

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    <>{children}</>
                </div>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const BuyerFields = (props) => {
    const userContext = useContext(UserContext)
    const userProductContext = useContext(ProductContext)
    const customCommonContext = useContext(CustomCommonContext)
    // const { allCountries, allStates } = useContext(ProductCommonContext)
    const authContext = useContext(AuthContext)
    const {
        single_user,
        getSingleUser,
        userAction,
        responseStatus: responseStatusUser,
    } = userContext
    const { t } = useTranslation()

    const { search_alldashboardproducts, getAllDashboardProducts } =
        userProductContext

    const {
        user,
        loadUser,
        updateProfile,
        responseStatus: responseStatus,
    } = authContext

    const data = props.data
    const toggleFullScreenPopup = props.function
    const [isLoading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(false)
    const [buttonData, setButtonData] = useState([])
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)

    const [mapDataValue, setMapDataValue] = useState([])

    const [resetMapData, setResetMapData] = useState(false)

    const [tableValue, setTableValue] = useState([])
    const [action, setAction] = useState('')

    const [formikValues, setFormikValues] = useState({})
    const [array, setArray] = useState([])

    const mapDataValueRef = useRef(mapDataValue)
    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })

    const handleMapDataValue = (childMapDataValue) => {
        setMapDataValue(childMapDataValue)
    }

    const [customValidation, setCustomValidation] = useState([])
    const [customInitialValues, setCustomInitialValues] = useState([])

    useEffect(() => {
        let customValidationTemp = {}
        let customInitial = props.customInitial

        customValidationTemp = {
            ...props.customValidation,
            email: Yup.string()
                .email('Invalid email format')
                .max(250, 'Maximum 250 characters')
                .required('Required'),
            confirm_email:
                data.status === 'new'
                    ? Yup.string()
                          .email('Invalid email format')
                          .oneOf([Yup.ref('email')], "Email's not match")
                          .required('Required!')
                    : Yup.string(),
            phone: Yup.string()
                .trim()
                .matches(/^[0-9- +()]*$/g, 'Only Numbers Are Allowed')
                .required('Required'),
            zip: Yup.string()
                .trim()
                .matches(/^[0-9]*$/g, 'Only numbers are allowed')
                .max(6, 'Maximum 6 characters')
                .min(5, 'Minimum 5 characters')
                .required('Required'),
        }
        setCustomInitialValues(customInitial)
        setCustomValidation(customValidationTemp)
    }, [props.fieldValue, props.customValidation, props.customInitial])

    // useEffect(() => {
    //     if (mapDataValueRef.current.length) {
    //         let tempMapData = mapDataValueRef.current
    //         tempMapData.map((mapValue) => {
    //             if (mapValue.name === 'date_closed') {
    //                 mapValue.minDate = dateTimeFormatFunction(
    //                     formikValues.date_added ? formikValues.date_added : null,
    //                 )
    //                 mapValue.minDateMessage = `Date should not be before minimal date ${dateTimeFormatFunction(
    //                     formikValues.date_added ? formikValues.date_added : null,
    //                 )}`
    //                 mapValue.disablePast = true
    //             } else if (mapValue.name === 'date_added') {
    //                 mapValue.disablePast = true
    //             } else if (mapValue.name === 'sprice') {
    //                 mapValue.disabled = formikValues.auction ? false : true
    //             } else if (mapValue.name === 'rprice') {
    //                 mapValue.disabled = formikValues.auction ? false : true
    //             } else if (mapValue.name === 'bprice') {
    //                 mapValue.disabled = formikValues.buynow ? false : true
    //             }
    //         })
    //         setReload(!reload)
    //         // setMapDataValue(tempMapData)
    //         // setResetMapData(true)
    //     }
    // }, [formikValues])

    const additionalFormikUpdate = (data) => {
        if (props.additionalFormikUpdate) {
            props.additionalFormikUpdate(data)
        }
        setFormikValues(data)
    }

    const submitFunction = () => {
        let value = formikValues
        setIsLoading(true)
        if (value.both_access && !value.admin) {
            value.admin = 1
            value.is_requested = 0
        }
        userAction(value)
    }
    useEffect(() => {
        if (props.loadOff) {
            if (
                responseStatusUser &&
                responseStatusUser.from == 'userAction' &&
                responseStatusUser.status == 'success'
            ) {
                setIsLoading(false)
            }
        }
    }, [responseStatusUser])
    const formSubmit = (value, data) => {
        setFormikValues({
            ...formikValues,
            market_status: data,
        })
        submitFunction()
    }

    const cancelSubmit = () => {
        setIsLoading(false)
        toggleFullScreenPopup(false, '', 0)
    }

    useEffect(() => {
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false)
        }, 1000)
        if (data.status !== 'edit') {
            if (data.status === 'new') {
                setFormikValues({
                    ...formikValues,
                    id: 0,
                })
            }
        }
    }, [data.id])

    useEffect(() => {
        const buttonDataTemp = []
        if (formikValues.id) {
            if (formikValues.market_status === 'draft') {
                buttonDataTemp.push({
                    type: 'button',
                    style: 'secondary',
                    label: t('SAVE AS DRAFT'),
                    additionalValue: 'draft',
                })
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: t('submit'),
                    additionalValue: 'open',
                })
            }
            if (formikValues.market_status === '') {
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: t('UPDATE'),
                    additionalValue: 'open',
                })
            } else {
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: t('UPDATE'),
                    additionalValue: 'open',
                })
            }
        } else {
            buttonDataTemp.push({
                type: 'submit',
                style: 'primary',
                label: t('submit'),
                additionalValue: 'open',
            })
        }
        setButtonData(buttonDataTemp)
    }, [formikValues.id, formikValues.market_status])

    const [value, setValue] = useState(0)

    const handleChange = (newValue) => {
        setValue(newValue)
    }

    useEffect(() => {
        setValue(0)
    }, [data.popup])

    const notesValidation = Yup.object({
        reject_notes: Yup.string().required('Required'),
    })

    const notesFormik = useFormik({
        initialValues: {
            id: 0,
            email: '',
            reject_notes: '',
        },
        validationSchema: notesValidation,
        onSubmit: (values) => {
            userAction(values)
        },
    })

    const notesField = {
        formik: notesFormik,
        data: [
            {
                label: t('Notes'),
                type: 'textarea',
                placeholder: 'Enter notes',
                class: 'col-12',
                name: 'reject_notes',
            },
        ],
    }

    useEffect(() => {
        if (single_user) {
            notesFormik.values.reject_notes = single_user.record.reject_notes
            notesFormik.values.id = single_user.record.id
            notesFormik.values.email = single_user.record.email
        }
    }, [single_user])

    const custom = {
        user_id: {
            value: single_user?.record?.id,
            type: 'in',
            field: 'p.user_id',
        },
    }

    useEffect(() => {
        getAllDashboardProducts({
            limit: 12,
            page: 1,
            orderby: 'p.date_closed, asc',
            order: '',
            user_id: single_user?.record?.id,
            action: action,
        })
    }, [action])

    useEffect(() => {
        if (
            search_alldashboardproducts &&
            search_alldashboardproducts?.records?.length
        ) {
            let dynamicValueAssign = search_alldashboardproducts
            setTableValue(dynamicValueAssign?.records)
        }
    }, [action])
    console.log(search_alldashboardproducts, 'search_alldashboardproducts')
    console.log(action, 'checkAction')
    console.log(tableValue, 'checkTableValue')

    const validationPassword = Yup.object({
        change_password: Yup.boolean(),
        new_password: Yup.string()
            .notOneOf(
                [Yup.ref('current_password')],
                'New password must be different'
            )
            .min(8, 'Minimum 8 characters')
            .required('Required'),
        confirm_password: Yup.string()
            .oneOf([Yup.ref('new_password')], 'Passwords Not Match')
            .required('Required'),
    })

    const formikPassword = useFormik({
        initialValues: {
            id: 0,
            noCurrentCheck: true,
            change_password: 1,
            current_password: '',
            new_password: '',
            confirm_password: '',
        },
        validationSchema: validationPassword,
        onSubmit: (values) => {
            console.log(values, 'changepassword ', props.data)
            if (values.id) {
                userAction(values)
                setIsLoading(true)
            }
        },
    })

    useEffect(() => {
        if (
            responseStatusUser?.status === 'success' &&
            responseStatusUser?.from === 'userAction'
        ) {
            formikPassword.resetForm()
        }
    }, [responseStatusUser])

    const passwordChange = [
        {
            label: 'Password',
            name: 'new_password',
            type: showPassword ? 'text' : 'password',
            placeholder: 'Enter your New password',
            class: 'col-md-6 col-sm-12',
            endAdornment: (
                <InputAdornment position="end">
                    <IconButton
                        aria-label="password visibility"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() =>
                            setShowPassword((showPassword) => !showPassword)
                        }
                        edge="end"
                    >
                        {showPassword ? (
                            <span className="material-icons">
                                visibility_off
                            </span>
                        ) : (
                            <span className="material-icons">visibility</span>
                        )}
                    </IconButton>
                </InputAdornment>
            ),
        },
        {
            label: 'Confirm password',
            name: 'confirm_password',
            type: showConfirmPassword ? 'text' : 'password',
            placeholder: 'Re enter your password',
            class: 'col-md-6 col-sm-12',
            endAdornment: (
                <InputAdornment position="end">
                    <IconButton
                        aria-label="password visibility"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() =>
                            setShowConfirmPassword(
                                (showConfirmPassword) => !showConfirmPassword
                            )
                        }
                        edge="end"
                    >
                        {showConfirmPassword ? (
                            <span className="material-icons">
                                visibility_off
                            </span>
                        ) : (
                            <span className="material-icons">visibility</span>
                        )}
                    </IconButton>
                </InputAdornment>
            ),
        },
    ]

    return props.standalone ? (
        <>
            <div className="addUserModal">
                <div className="fspBody">
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <div className="customerDetailTabs">
                            <AppBar position="static">
                                <Tabs
                                    value={value}
                                    // onChange={handleChange}
                                    aria-label="simple tabs example"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                >
                                    <Tab
                                        label={t('PROFILE')}
                                        value={0}
                                        onClick={() => handleChange(0)}
                                    />
                                    {props.invoiceTab ? (
                                        <Tab
                                            label={t('Invoices')}
                                            value={1}
                                            onClick={() => handleChange(1)}
                                        />
                                    ) : null}
                                    <Tab
                                        label={t('NOTIFICATIONS')}
                                        value={2}
                                        onClick={() => handleChange(2)}
                                    />
                                    <Tab
                                        label={t('LOGIN INFO')}
                                        value={3}
                                        onClick={() => handleChange(3)}
                                    />
                                    <Tab
                                        label={t('Notes')}
                                        value={4}
                                        onClick={() => handleChange(4)}
                                    />
                                    {!props.noCredits ? (
                                        <Tab
                                            label={
                                                props.creditLabel
                                                    ? t(props.creditLabel)
                                                    : t('CREDITS')
                                            }
                                            value={5}
                                            onClick={() => handleChange(5)}
                                        />
                                    ) : null}

                                    <Tab
                                        label={t('MAIL LOGS')}
                                        value={6}
                                        onClick={() => handleChange(6)}
                                    />
                                    <Tab
                                        label={t('SMS LOGS')}
                                        value={7}
                                        onClick={() => handleChange(7)}
                                    />
                                    <Tab
                                        label={t('Bid history')}
                                        value={8}
                                        onClick={() => handleChange(8)}
                                    />
                                    <Tab
                                        label={t('Dashboard')}
                                        value={9}
                                        onClick={() => handleChange(9)}
                                    />
                                    {/* <Tab
                                        label="Winning Lots"
                                        {...a11yProps(9)}
                                        onClick={() => setAction('winning')}
                                    />
                                    <Tab
                                        label="Outbid Lots"
                                        {...a11yProps(10)}
                                        onClick={() => setAction('outbid')}
                                    />
                                    <Tab
                                        label="Won Lots"
                                        {...a11yProps(11)}
                                        onClick={() => setAction('won')}
                                    /> */}
                                </Tabs>
                            </AppBar>
                            <TabPanel value={value} index={0}>
                                <BaseActionPage
                                    arrayValue={props.fieldValue}
                                    data={props.data}
                                    additionalFormikUpdate={
                                        additionalFormikUpdate
                                    }
                                    editFunction={getSingleUser}
                                    editValue={single_user}
                                    handleMapDataValue={handleMapDataValue}
                                    actionFunction={formSubmit}
                                    cancelFunction={cancelSubmit}
                                    buttonAction={buttonData}
                                    customValidation={customValidation}
                                    customInitialValues={customInitialValues}
                                    changePassword={props.changePassword}
                                    passwordChange={passwordChange}
                                    formikPassword={formikPassword}
                                    // mapDataValue={mapDataValue}
                                    // resetMapData={resetMapData}
                                    // setResetMapData={setResetMapData}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <UserInvoices
                                    userId={single_user?.record?.user_id}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={2}>
                                <UserNotifications
                                    data={single_user?.record}
                                    cancelFunction={cancelSubmit}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={3}>
                                <LoginInfo data={single_user?.record} />
                            </TabPanel>
                            <TabPanel value={value} index={4}>
                                <>
                                    <form
                                        onSubmit={notesFormik.handleSubmit}
                                        autoComplete="nofill"
                                    >
                                        <div className="row">
                                            {mapData(notesField)}
                                        </div>
                                        <PrimaryButton
                                            type="submit"
                                            label={t('SAVE')}
                                            btnSize="notifBtn"
                                        />
                                    </form>
                                </>
                            </TabPanel>
                            <TabPanel value={value} index={5}>
                                <Credits
                                    data={single_user?.record}
                                    creditTextChange={props.creditTextChange}
                                    creditLabel={props.creditLabel}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={6}>
                                <UserEmailLogs
                                    userId={single_user?.record?.user_id}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={7}>
                                <UserSmsLogs
                                    userId={single_user?.record?.user_id}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={8}>
                                <UserBidHistory
                                    userId={single_user?.record?.user_id}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={9}>
                                <BuyerBids
                                    userId={single_user?.record?.user_id}
                                />
                            </TabPanel>

                            {/* <TabPanel value={value} index={9}>
                                <ListingTableView
                                    customFilter={custom}
                                    tableValue={tableValue}
                                    tableActionString={['open', 'auction_assign']}
                                    listActionString={['bidcount']}
                                    action="winning"
                                />
                            </TabPanel>
                            <TabPanel value={value} index={10}>
                                <ListingTableView
                                    customFilter={custom}
                                    tableValue={tableValue}
                                    tableActionString={['open', 'auction_assign']}
                                    listActionString={['bidcount']}
                                    action="outbid"
                                />
                            </TabPanel>
                            <TabPanel value={value} index={11}>
                                <ListingTableView
                                    customFilter={custom}
                                    tableValue={tableValue}
                                    tableActionString={['open', 'auction_assign']}
                                    listActionString={['bidcount']}
                                    action="won"
                                />
                            </TabPanel> */}
                        </div>
                    )}
                </div>
            </div>
        </>
    ) : (
        <FullScreenPopup
            modaltitle={
                data.status === 'new' ? t('ADD NEW USER') : t('EDIT USER')
            }
            open={
                data.status === 'edit' || data.status === 'new'
                    ? data.popup
                    : false
            }
            handleClose={() => {
                setIsLoading(false), toggleFullScreenPopup(false, '', 0)
            }}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <div className="customerDetailTabs">
                            <AppBar position="static">
                                <Tabs
                                    value={value}
                                    // onChange={handleChange}
                                    aria-label="simple tabs example"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                >
                                    <Tab
                                        label={t('PROFILE')}
                                        value={0}
                                        onClick={() => handleChange(0)}
                                    />
                                    {props.invoiceTab ? (
                                        <Tab
                                            label={t('Invoices')}
                                            value={1}
                                            onClick={() => handleChange(1)}
                                        />
                                    ) : null}
                                    <Tab
                                        label={t('NOTIFICATIONS')}
                                        value={2}
                                        onClick={() => handleChange(2)}
                                    />
                                    <Tab
                                        label={t('LOGIN INFO')}
                                        value={3}
                                        onClick={() => handleChange(3)}
                                    />
                                    <Tab
                                        label={t('Notes')}
                                        value={4}
                                        onClick={() => handleChange(4)}
                                    />
                                    {!props.noCredits ? (
                                        <Tab
                                            label={t('CREDITS')}
                                            value={5}
                                            onClick={() => handleChange(5)}
                                        />
                                    ) : null}
                                    <Tab
                                        label={t('MAIL LOGS')}
                                        value={6}
                                        onClick={() => handleChange(6)}
                                    />
                                    <Tab
                                        label={t('SMS LOGS')}
                                        value={7}
                                        onClick={() => handleChange(7)}
                                    />
                                    <Tab
                                        label={t('Bid History')}
                                        value={8}
                                        onClick={() => handleChange(8)}
                                    />
                                    <Tab
                                        label={t('Dashboard')}
                                        value={9}
                                        onClick={() => handleChange(9)}
                                    />
                                    {/* <Tab
                                        label="Winning Lots"
                                        {...a11yProps(9)}
                                        onClick={() => setAction('winning')}
                                    />
                                    <Tab
                                        label="Outbid Lots"
                                        {...a11yProps(10)}
                                        onClick={() => setAction('outbid')}
                                    />
                                    <Tab
                                        label="Won Lots"
                                        {...a11yProps(11)}
                                        onClick={() => setAction('won')}
                                    /> */}
                                </Tabs>
                            </AppBar>
                            <TabPanel value={value} index={0}>
                                <BaseActionPage
                                    arrayValue={props.fieldValue}
                                    data={props.data}
                                    additionalFormikUpdate={
                                        additionalFormikUpdate
                                    }
                                    editFunction={getSingleUser}
                                    editValue={single_user}
                                    handleMapDataValue={handleMapDataValue}
                                    actionFunction={formSubmit}
                                    cancelFunction={cancelSubmit}
                                    buttonAction={buttonData}
                                    customValidation={customValidation}
                                    customInitialValues={customInitialValues}
                                    changePassword={props.changePassword}
                                    passwordChange={passwordChange}
                                    formikPassword={formikPassword}
                                    // mapDataValue={mapDataValue}
                                    // resetMapData={resetMapData}
                                    // setResetMapData={setResetMapData}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <UserInvoices
                                    userId={single_user?.record?.user_id}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={2}>
                                <UserNotifications
                                    data={single_user?.record}
                                    cancelFunction={cancelSubmit}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={3}>
                                <LoginInfo data={single_user?.record} />
                            </TabPanel>
                            <TabPanel value={value} index={4}>
                                <>
                                    <form
                                        onSubmit={notesFormik.handleSubmit}
                                        autoComplete="nofill"
                                    >
                                        <div className="row">
                                            {mapData(notesField)}
                                        </div>
                                        <PrimaryButton
                                            type="submit"
                                            label={t('SAVE')}
                                            btnSize="notifBtn"
                                        />
                                    </form>
                                </>
                            </TabPanel>
                            <TabPanel value={value} index={5}>
                                <Credits data={single_user?.record} />
                            </TabPanel>
                            <TabPanel value={value} index={6}>
                                <UserEmailLogs
                                    userId={single_user?.record?.user_id}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={7}>
                                <UserSmsLogs
                                    userId={single_user?.record?.user_id}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={8}>
                                <UserBidHistory
                                    userId={single_user?.record?.user_id}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={9}>
                                <BuyerBids
                                    userId={single_user?.record?.user_id}
                                />
                            </TabPanel>

                            {/* <TabPanel value={value} index={9}>
                                <ListingTableView
                                    customFilter={custom}
                                    tableValue={tableValue}
                                    tableActionString={['open', 'auction_assign']}
                                    listActionString={['bidcount']}
                                    action="winning"
                                />
                            </TabPanel>
                            <TabPanel value={value} index={10}>
                                <ListingTableView
                                    customFilter={custom}
                                    tableValue={tableValue}
                                    tableActionString={['open', 'auction_assign']}
                                    listActionString={['bidcount']}
                                    action="outbid"
                                />
                            </TabPanel>
                            <TabPanel value={value} index={11}>
                                <ListingTableView
                                    customFilter={custom}
                                    tableValue={tableValue}
                                    tableActionString={['open', 'auction_assign']}
                                    listActionString={['bidcount']}
                                    action="won"
                                />
                            </TabPanel> */}
                        </div>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default BuyerFields
